import React from "react";
import cx from "classnames";
import * as styles from "./BetCard.module.scss";
import { Box } from "components/Box";

type BetCardProps = {
  message?: string | JSX.Element | null;
  className?: string;
  children?: React.ReactNode;
};

export const BetCard = ({ message, className, children }: BetCardProps) => (
  <>
    {message && <div>{message}</div>}
    <Box
      className={cx(styles.card, className)}
      childrenClassName={styles.pick}
      hideHeader
    >
      {children}
    </Box>
  </>
);
